import { LatLngBounds, map, divIcon } from 'leaflet';
import styles from './Viewer.module.scss';

const getDefaultZoom = (deepzoomSize: any, containerSize: any) => {
  const { width: dw, height: dh } = deepzoomSize;
  const { width: cw, height: ch } = containerSize;
  return Math.log(cw / ch > dw / dh ? dh / ch : dw / cw) / Math.log(2);
};

export const getMapProps = (deepzoom: any, rect: any) => {
  if (deepzoom && rect.width && rect.height) {
    const zoom = deepzoom.maxZoom - getDefaultZoom(deepzoom, rect);
    const maxZoom = Math.max(zoom, deepzoom.maxZoom);
    const minZoom = Math.max(zoom, deepzoom.minZoom);
    const tmp = map(document.createElement('DIV'), {
      maxZoom,
      minZoom,
      zoomSnap: 0,
    });
    const southWest = tmp.unproject([0, deepzoom.height], tmp.getMaxZoom());
    const northEast = tmp.unproject([deepzoom.width, 0], tmp.getMaxZoom());
    const maxBounds = new LatLngBounds(southWest, northEast);
    return {
      style: { width: rect.width, height: rect.height },
      zoom,
      maxZoom,
      minZoom,
      zoomSnap: 0,
      zoomControl: false,
      attributionControl: false,
      center: [
        (northEast.lat + southWest.lat) / 2,
        (northEast.lng + southWest.lng) / 2,
      ],
      maxBounds,
    };
  }

  return undefined;
};
const identity = (e: any) => e;

export const getIcon = (type: string, done?: boolean) =>
  divIcon({
    className: [styles.marker, styles[`marker-${type}`], done && styles.done].filter(identity).join(' '),
    iconSize: [28, 36],
    iconAnchor: [14, 36],
    popupAnchor: [0, -36],
    html: `<span class="icon-${type}" />`,
  });
